module.exports = __webpack_public_path__ + "img/Group_1209.43a561d0.png";